import React, { useRef, useState, useCallback } from 'react';
import styled from 'styled-components';
import mapboxgl from 'mapbox-gl';
import MapComponent from '../map/MapComponent';
import Sidebar from '../sidebar/Sidebar';
import { eventsService } from '../../services/events.service';

const ProspectionContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
`;

interface ProspectionViewProps {
  onAddCategory?: () => void;
}

const ProspectionView: React.FC<ProspectionViewProps> = ({ onAddCategory }) => {
  const mapRef = useRef<mapboxgl.Map | null>(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  
  // Référence pour la fonction d'ajout de catégorie
  const addCategoryRef = useRef<(() => void) | null>(null);

  const handleMapInit = useCallback((ref: React.MutableRefObject<mapboxgl.Map | null>) => {
    mapRef.current = ref.current;
  }, []);

  const handleToggleSidebar = useCallback(() => {
    const newState = !isSidebarCollapsed;
    setIsSidebarCollapsed(newState);
    
    // Émettre l'événement pour informer les autres composants
    eventsService.emit('SIDEBAR_TOGGLE' as any, { isCollapsed: newState });
    
    // Forcer un rafraîchissement de la carte après un court délai pour s'adapter à la nouvelle taille
    setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.resize();
      }
    }, 300);
  }, [isSidebarCollapsed, mapRef]);

  const handleAddCategory = useCallback(() => {
    // Appeler la méthode handleAddCategory du composant Sidebar via la référence
    if (addCategoryRef.current) {
      addCategoryRef.current();
    }
    // Appeler également la fonction passée en prop si elle existe
    if (onAddCategory) {
      onAddCategory();
    }
  }, [addCategoryRef, onAddCategory]);

  return (
    <ProspectionContainer>
      <Sidebar 
        mapRef={mapRef} 
        isCollapsed={isSidebarCollapsed}
        onToggleSidebar={handleToggleSidebar}
        onAddCategoryRef={addCategoryRef}
      />
      <MapComponent 
        onMapInit={handleMapInit} 
        onAddCategory={handleAddCategory}
      />
    </ProspectionContainer>
  );
};

export default ProspectionView;
